export default class FakeLocalStorage {
  constructor() {
    this.store = {};
    this.getItem = this.getItem.bind(this);
    this.setItem = this.setItem.bind(this);
  }

  getItem(key) {
    return this.store[key];
  }

  setItem(key, value) {
    this.store[key] = value;
  }

  clear() {
    this.store = {};
  }
}
